import { useOtherPropertiesFieldBindings } from "@Client/@Composables/application-standalone/pages/other-properties/useOtherPropertiesFieldBindings";
import { useOtherPropertiesFieldVisibility } from "@Client/@Composables/application-standalone/pages/other-properties/useOtherPropertiesFieldVisibility";
export const otherPropertiesBindingsAndVisibilities = (applicantIndex, otherPropertyIndex, applicantId) => {
  const {
    purchasePrice,
    estimatedValue,
    purchaseDate,
    address,
    propertyOwner,
    feesIncludeHeat,
    heating,
    includeInTds,
    maintenanceFees,
    percOfTotalMaintFees,
    propertyTaxes,
    hydro,
    insurance,
    interest,
    management,
    monthlyIncome,
    occupancy,
    others,
    repairs,
    rentalIncomeOptions,
    rentalIncomeOptionsPercent,
    otherPropertyFromApplicant
  } = useOtherPropertiesFieldBindings({
    applicantIndex,
    otherPropertyIndex
  });
  const {
    otherPropertyPurchasePriceVisibility,
    otherPropertyEstimatedValueVisibility,
    otherPropertyPurchaseDateVisibility,
    otherPropertyAddressVisibility,
    otherPropertyFeesIncludeHeatVisibility,
    otherPropertyHeatingVisibility,
    otherPropertyIncludeInTdsVisibility,
    otherPropertyMaintenanceFeesVisibility,
    otherPropertyPercOfTotalMaintFeesVisibility,
    otherPropertyPropertyTaxesVisibility,
    otherPropertyHydroVisibility,
    otherPropertyInsuranceVisibility,
    otherPropertyInterestVisibility,
    otherPropertyManagementVisibility,
    otherPropertyMonthlyIncomeVisibility,
    otherPropertyOccupancyVisibility,
    otherPropertyOthersVisibility,
    otherPropertyRepairsVisibility,
    otherPropertyRentalIncomeOptionsVisibility,
    otherPropertyRentalIncomeOptionsPercentVisibility
  } = useOtherPropertiesFieldVisibility({
    applicantIndex,
    otherPropertyIndex,
    applicantId
  });
  return {
    bindings: {
      purchasePrice,
      estimatedValue,
      purchaseDate,
      address,
      propertyOwner,
      feesIncludeHeat,
      heating,
      includeInTds,
      maintenanceFees,
      percOfTotalMaintFees,
      propertyTaxes,
      hydro,
      insurance,
      interest,
      management,
      monthlyIncome,
      occupancy,
      others,
      repairs,
      rentalIncomeOptions,
      rentalIncomeOptionsPercent,
      otherPropertyFromApplicant
    },
    visibilities: {
      otherPropertyPurchasePriceVisibility,
      otherPropertyEstimatedValueVisibility,
      otherPropertyPurchaseDateVisibility,
      otherPropertyAddressVisibility,
      otherPropertyFeesIncludeHeatVisibility,
      otherPropertyHeatingVisibility,
      otherPropertyIncludeInTdsVisibility,
      otherPropertyMaintenanceFeesVisibility,
      otherPropertyPercOfTotalMaintFeesVisibility,
      otherPropertyPropertyTaxesVisibility,
      otherPropertyHydroVisibility,
      otherPropertyInsuranceVisibility,
      otherPropertyInterestVisibility,
      otherPropertyManagementVisibility,
      otherPropertyMonthlyIncomeVisibility,
      otherPropertyOccupancyVisibility,
      otherPropertyOthersVisibility,
      otherPropertyRepairsVisibility,
      otherPropertyRentalIncomeOptionsVisibility,
      otherPropertyRentalIncomeOptionsPercentVisibility
    }
  };
};